/**
 * Linear interpolation between two numbers.
 */
export function lerp(value: number, low: number, high: number): number {
	return low + (high - low) * value
}

export function slerp(value: number, low: number, high: number): number {
	return Math.sin(lerp(value, 0, Math.PI / 2)) * (high - low) + low
}

export function retreiveSlerpValue(result: number, low: number, high: number): number {
	return Math.asin((result - low) / (high - low)) / (Math.PI / 2)
}
